const REF_PARAM_KEY = "ref";
const REF_PARAM_VALUE = "yourwebsitescore";
const FEATURED_SPOT_PARAMS = {
  [REF_PARAM_KEY]: REF_PARAM_VALUE,
  utm_source: "yourwebsitescore",
  utm_medium: "featured_spot",
  utm_campaign: "featured_ads",
};

function appendQueryParams(
  input: string,
  params: Record<string, string>
): string {
  const candidates = [input];
  if (!/^https?:\/\//i.test(input)) {
    candidates.push(`https://${input}`);
  }

  for (const candidate of candidates) {
    try {
      const url = new URL(candidate);
      for (const [key, value] of Object.entries(params)) {
        if (!url.searchParams.has(key)) {
          url.searchParams.append(key, value);
        }
      }
      return url.toString();
    } catch {
      continue;
    }
  }

  return input;
}

export function appendRefParam(input: string): string {
  return appendQueryParams(input, { [REF_PARAM_KEY]: REF_PARAM_VALUE });
}

export function appendFeaturedSpotTracking(input: string): string {
  return appendQueryParams(input, FEATURED_SPOT_PARAMS);
}

export function extractHostname(input: string): { hostname: string; href: string | null } {
  let hostname = input;
  let href: string | null = null;

  try {
    const urlObj = new URL(input);
    hostname = urlObj.hostname;
    if (urlObj.protocol === "http:" || urlObj.protocol === "https:") {
      href = appendRefParam(urlObj.href);
    }
  } catch {
    try {
      const guessUrl = new URL(`https://${input}`);
      hostname = guessUrl.hostname;
      href = appendRefParam(guessUrl.href);
    } catch {
      hostname = input;
      href = null;
    }
  }

  return { hostname, href };
}

export function formatDisplayUrl(url: string): string {
  return url.replace(/^https?:\/\//, "");
}
